import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dialog-popup',
  standalone: true,
  templateUrl: './dialog-popup.component.html',
  styleUrls: ['./dialog-popup.component.scss'],
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule, FlexLayoutModule]
})
export class DialogPopupComponent {
  readonly _dialogRef: MatDialogRef<DialogPopupComponent> = inject(MatDialogRef<DialogPopupComponent>);
  private data: any = inject(MAT_DIALOG_DATA);

  redirect() {
    this._dialogRef.close('redirect');
  }
  closePopup() {
    this._dialogRef.close();
  }
}
